"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFutureLeverage = exports.useFutureLeverage = exports.useFutureLeverages = exports.refreshLeveragesAction = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const FutureAPI_1 = require("../../../apis/FutureAPI");
const trade_utils_lib_1 = require("trade_utils_lib");
const CustomAssetsProvider_1 = require("../../CustomAssetsProvider");
const FetchLeverage = () => {
    const fetchData = (0, FutureAPI_1.querySymbolLeverages)();
    const modelParam = {
        keyId: "common_data",
        dataKey: "future_leverage_provider",
        expireTime: trade_utils_lib_1.EXPIRED_TYPE.NEVER,
        refresh: () => fetchData,
    };
    return (0, trade_utils_lib_1.getDataWithCache)(modelParam);
};
const triggerSubject = new rxjs_1.Subject();
const publish$ = (0, rxjs_1.merge)((0, rxjs_1.timer)(0, 5000), triggerSubject).pipe((0, operators_1.switchMap)(() => {
    return FetchLeverage().pipe((0, operators_1.map)((res) => {
        var _a;
        const lMap = new Map();
        (_a = res === null || res === void 0 ? void 0 : res.leverages) === null || _a === void 0 ? void 0 : _a.forEach((e) => {
            lMap.set(e.symbol, e);
        });
        return {
            leverages: res.leverages,
            leverageMap: lMap,
            error: undefined,
        };
    }), (0, operators_1.catchError)((error) => {
        return (0, rxjs_1.of)({
            leverages: new Array(),
            leverageMap: new Map(),
            error: error,
        });
    }));
}), (0, operators_1.publishBehavior)({
    leverages: new Array(),
    leverageMap: new Map(),
}), (0, operators_1.refCount)());
const refreshLeveragesAction = () => {
    triggerSubject.next(new Date().getTime());
};
exports.refreshLeveragesAction = refreshLeveragesAction;
const useFutureLeverages = (active = true) => {
    const [value, setValue] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!active) {
            return;
        }
        const sub = publish$.subscribe({
            next: (res) => {
                setValue(res);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [active]);
    return { data: value };
};
exports.useFutureLeverages = useFutureLeverages;
const useFutureLeverage = (symbol, active = true) => {
    const [value, setValue] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (!active) {
            return;
        }
        const sub = publish$.subscribe({
            next: (res) => {
                const v = res.leverageMap.get(symbol);
                setValue(v);
                setError(res.error);
            },
            error: () => { },
        });
        return () => {
            sub.unsubscribe();
        };
    }, [symbol, active]);
    return { leverage: (value === null || value === void 0 ? void 0 : value.leverage) ? Number(value.leverage) : undefined, error: error };
};
exports.useFutureLeverage = useFutureLeverage;
/**更新传入的币对的杠杆倍数 */
function updateFutureLeverage(symbol, leverage) {
    const params = {
        symbol: symbol,
        leverage: `${leverage}`,
    };
    return (0, FutureAPI_1.setFuturesLeverage)(params).pipe((0, operators_1.tap)(() => {
        (0, CustomAssetsProvider_1.refreshAccountDetail)();
        (0, exports.refreshLeveragesAction)();
    }));
}
exports.updateFutureLeverage = updateFutureLeverage;
